var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("horse.menu_contacts")))]),_c('Contact',{attrs:{"horse_id":_vm.horse.horse_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }